export const joinWordsWithUnderscore = (text: string): string => {
  return text?.replaceAll(" ", "_")?.toLowerCase() || "";
};
